import {attributeFilter, nodeAddedMap} from './MutationHandler';
import {
  handleContentPlaceholders,
  isContentVimeoPlayer,
  isContentYouTubePlayer,
} from './utils';

const attribute = 'data-content-placeholder';

export const ContentPlaceholderController = Object.freeze({
  attribute,
  selector: `[${attribute}]`,
});

nodeAddedMap.set(ContentPlaceholderController.selector, (target) => {
  if (!target.matches(ContentPlaceholderController.selector)) {
    return;
  }

  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');

  const clickHandler = () => {
    target.removeEventListener('click', clickHandler);
    handleContentPlaceholders(target, (contentType, player) => {
      target.removeAttribute('role');
      target.removeAttribute('tabindex');

      if (isContentVimeoPlayer(contentType, player)) {
        player.play();
      } else if (isContentYouTubePlayer(contentType, player)) {
        player.playVideo();
      }
    });
  };
  target.addEventListener('click', clickHandler);
});

attributeFilter.add(attribute);
